import React, { Suspense } from 'react';
import { useBrandContext } from 'context/BrandProvider';

type AccentImageKey =
  | 'vortex'
  | 'hexagon'
  | 'dotPulse'
  | 'abstractGlobe'
  | 'prism';

const componentMap: Record<
  AccentImageKey,
  React.LazyExoticComponent<React.ComponentType>
> = {
  vortex: React.lazy(() => import('../assets/Vortex')),
  hexagon: React.lazy(() => import('../assets/Hexagon')),
  dotPulse: React.lazy(() => import('../assets/DotPulse')),
  abstractGlobe: React.lazy(() => import('../assets/AbstractGlobe')),
  prism: React.lazy(() => import('../assets/Prism')),
};

const AccentImage = () => {
  const { brand } = useBrandContext();

  const SelectedComponent =
    brand?.lpAccentImage && brand.lpAccentImage in componentMap
      ? componentMap[brand.lpAccentImage as AccentImageKey]
      : componentMap['vortex'];

  if (brand?.lpAccentImageCustom && brand?.lpAccentImage === 'custom') {
    return (
      <img
        src={brand.lpAccentImageCustom}
        alt="custom-accent"
        className="h-[259px] w-[225px] object-contain"
      />
    );
  }

  return (
    <Suspense fallback={null}>
      {SelectedComponent ? <SelectedComponent /> : null}
    </Suspense>
  );
};

export default AccentImage;
